import { render, staticRenderFns } from "./InvoicePaymentList.vue?vue&type=template&id=0ed35029&"
import script from "./InvoicePaymentList.vue?vue&type=script&lang=js&"
export * from "./InvoicePaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports